



























import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

import expiringStorage from './expiringStorage';

@Component({
    components: {},
})
export default class Tabs extends Vue {
    private tabs = [];
    private activeTabHash = '';
    private activeTabIndex = 0;
    private lastActiveTabHash = '';

    @Prop({ type: [Number], default: 5 })
    private cacheLifetime: number;

    @Prop({ type: [Object], required: true, default: () => ({ useUrlFragment: true, defaultTabHash: null }) })
    private options: {[key: string]: any};

    get storageKey() {
        return `vue-tabs-component.cache.${window.location.host}${window.location.pathname}`;
    }

    private created() {
        this.tabs = this.$children;
    }

    private mounted() {
        window.addEventListener('hashchange', () => this.selectTab(window.location.hash));

        if (this.findTab(window.location.hash)) {
            this.selectTab(window.location.hash);
            return;
        }

        const previousSelectedTabHash = expiringStorage.get(this.storageKey);

        if (this.findTab(previousSelectedTabHash)) {
            this.selectTab(previousSelectedTabHash);
            return;
        }

        if (this.options.defaultTabHash !== null && this.findTab('#' + this.options.defaultTabHash)) {
            this.selectTab('#' + this.options.defaultTabHash);
            return;
        }

        if (this.tabs.length) {
            this.selectTab(this.tabs[0].hash);
        }
    }

    private findTab(hash) {
        return this.tabs.find(tab => tab.hash === hash);
    }

    private selectTab(selectedTabHash, event?) {
        // See if we should store the hash in the url fragment.
        if (event && !this.options.useUrlFragment) {
            event.preventDefault();
        }

        const selectedTab = this.findTab(selectedTabHash);

        if (!selectedTab) {
            return;
        }

        if (selectedTab.isDisabled) {
            event.preventDefault();
            return;
        }

        if (this.lastActiveTabHash === selectedTab.hash) {
            this.$emit('clicked', { tab: selectedTab });
            return;
        }

        this.tabs.forEach(tab => {
            tab.isActive = tab.hash === selectedTab.hash;
        });

        this.$emit('changed', { tab: selectedTab });

        this.activeTabHash = selectedTab.hash;
        this.activeTabIndex = this.getTabIndex(selectedTabHash);

        this.lastActiveTabHash = this.activeTabHash = selectedTab.hash;

        expiringStorage.set(this.storageKey, selectedTab.hash, this.cacheLifetime);
    }

    private setTabVisible(hash, visible) {
        const tab = this.findTab(hash);

        if (!tab) {
            return;
        }

        tab.isVisible = visible;

        if (tab.isActive) {
            // If tab is active, set a different one as active.
            tab.isActive = visible;

            this.tabs.every((tab, index, array) => {
                if (tab.isVisible) {
                    tab.isActive = true;

                    return false;
                }

                return true;
            });
        }
    }

    private getTabIndex(hash) {
        const tab = this.findTab(hash);

        return this.tabs.indexOf(tab);
    }

    private getTabHash(index) {
        const tab = this.tabs.find(tab => this.tabs.indexOf(tab) === index);

        if (!tab) {
            return;
        }

        return tab.hash;
    }

    private getActiveTab() {
        return this.findTab(this.activeTabHash);
    }

    private getActiveTabIndex() {
        return this.getTabIndex(this.activeTabHash);
    }
}
